import { useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import BrandButtonView from '../../common/BrandButton';
import { formatPortalCopy } from '../../common/formatCopy';
import EntitySearchResultItem from './EntitySearchResultItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Step 1 Find your agency: search and select an entity, or switch to registering a new agency */
var EntitySearchPanel = function EntitySearchPanel(props) {
  var entities = props.entities,
      copy = props.copy,
      onContinue = props.onContinue,
      onRegisterInstead = props.onRegisterInstead,
      onContactBroker = props.onContactBroker;

  var _useState = useState(''),
      query = _useState[0],
      setQuery = _useState[1];

  var _useState2 = useState(''),
      appliedQuery = _useState2[0],
      setAppliedQuery = _useState2[1];

  var _useState3 = useState(''),
      selectedId = _useState3[0],
      setSelectedId = _useState3[1];

  var normalizedQuery = appliedQuery.trim().toLowerCase();
  var matchedEntities = normalizedQuery ? entities.filter(function (item) {
    return "".concat(item.name, " ").concat(item.location || '').toLowerCase().includes(normalizedQuery);
  }) : entities;
  var selectedEntity = entities.find(function (item) {
    return item.id === selectedId;
  });
  /**
   * methods
   */

  var searchAction = function searchAction() {
    setAppliedQuery(query);
  };

  var searchKeyDownAction = function searchKeyDownAction(event) {
    if (event.key === 'Enter') searchAction();
  };

  var selectEntityAction = function selectEntityAction(entity) {
    setSelectedId(entity.id);
  };

  var continueAction = function continueAction() {
    if (selectedEntity) onContinue(selectedEntity);
  };

  var registerInsteadAction = function registerInsteadAction() {
    onRegisterInstead();
  };

  var contactBrokerAction = function contactBrokerAction() {
    onContactBroker === null || onContactBroker === void 0 ? void 0 : onContactBroker();
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: "flex w-full flex-col space-y-6",
    children: [/*#__PURE__*/_jsxs(Box, {
      className: "flex flex-row space-x-3 rounded-2xl bg-[#3B5BFF]/10 px-5 py-4",
      children: [/*#__PURE__*/_jsx(Box, {
        component: "svg",
        viewBox: "0 0 24 24",
        className: "mt-0.5 h-5 w-5 flex-shrink-0 fill-[#3B5BFF]",
        children: /*#__PURE__*/_jsx("path", {
          d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1 5h2v2h-2V7zm0 4h2v6h-2v-6z"
        })
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-sm leading-6 text-[#12275B]",
        children: copy === null || copy === void 0 ? void 0 : copy.banner
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-row space-x-3",
      children: [/*#__PURE__*/_jsx(TextField, {
        fullWidth: true,
        size: "small",
        value: query,
        placeholder: copy === null || copy === void 0 ? void 0 : copy.searchPlaceholder,
        onChange: function onChange(event) {
          return setQuery(event.target.value);
        },
        onKeyDown: searchKeyDownAction
      }), /*#__PURE__*/_jsx(BrandButtonView, {
        onClick: searchAction,
        children: copy === null || copy === void 0 ? void 0 : copy.searchText
      })]
    }), !!appliedQuery.trim() && /*#__PURE__*/_jsx(Typography, {
      className: "text-sm text-gray-500",
      children: formatPortalCopy(copy === null || copy === void 0 ? void 0 : copy.matchCountText, {
        count: matchedEntities.length,
        query: appliedQuery.trim()
      })
    }), /*#__PURE__*/_jsx(Box, {
      className: "flex flex-col space-y-3",
      children: matchedEntities.map(function (entity) {
        return /*#__PURE__*/_jsx(EntitySearchResultItem, {
          entity: entity,
          selected: selectedId === entity.id,
          onSelect: selectEntityAction
        }, entity.id);
      })
    }), /*#__PURE__*/_jsx(BrandButtonView, {
      size: "large",
      className: "w-full",
      disabled: !selectedEntity,
      onClick: continueAction,
      children: copy === null || copy === void 0 ? void 0 : copy.continueText
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col space-y-4 rounded-2xl border border-black/10 bg-white p-6",
      children: [/*#__PURE__*/_jsxs(Box, {
        className: "flex flex-row items-start space-x-3",
        children: [/*#__PURE__*/_jsx(Box, {
          component: "svg",
          viewBox: "0 0 24 24",
          className: "mt-0.5 h-5 w-5 flex-shrink-0 fill-[#3B5BFF]",
          children: /*#__PURE__*/_jsx("path", {
            d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1 5h2v2h-2V7zm0 4h2v6h-2v-6z"
          })
        }), /*#__PURE__*/_jsxs(Box, {
          className: "flex flex-col space-y-2",
          children: [/*#__PURE__*/_jsx(Typography, {
            className: "text-sm font-extrabold text-[#3B5BFF]",
            children: copy === null || copy === void 0 ? void 0 : copy.cantFindTitle
          }), /*#__PURE__*/_jsx(Typography, {
            className: "text-sm leading-6 text-gray-600",
            children: copy === null || copy === void 0 ? void 0 : copy.cantFindDesc
          })]
        })]
      }), /*#__PURE__*/_jsx(BrandButtonView, {
        className: "w-full",
        onClick: contactBrokerAction,
        children: copy === null || copy === void 0 ? void 0 : copy.contactText
      }), /*#__PURE__*/_jsxs(Typography, {
        className: "text-sm text-gray-500",
        children: [copy === null || copy === void 0 ? void 0 : copy.registerHint, ' ', /*#__PURE__*/_jsx(Typography, {
          component: "span",
          className: "cursor-pointer text-sm font-bold text-[#3B5BFF] hover:underline",
          onClick: registerInsteadAction,
          children: copy === null || copy === void 0 ? void 0 : copy.registerText
        })]
      })]
    })]
  });
};

export default EntitySearchPanel;